/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { GlobalWorkTypesSettingsConfigProviderEntryEntrypointProps } from './GlobalWorkTypesSettingsConfigProviderEntry.entrypoint.types.tsx';

type GlobalWorkTypesSettingsConfigProviderEntrypointComponent = EntryPointComponent<
	{},
	{},
	GlobalWorkTypesSettingsConfigProviderEntryEntrypointProps,
	{} | null
>;

export const globalWorkTypesSettingsConfigProviderEntrypoint: EntryPoint<
	GlobalWorkTypesSettingsConfigProviderEntrypointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<GlobalWorkTypesSettingsConfigProviderEntrypointComponent>(
		/* webpackChunkName: "ai-rovo-action-settings-provider" */ './GlobalWorkTypesSettingsConfigProviderEntry.tsx',
	),
	getPreloadProps: () => ({}),
});
